import { defineStore } from 'pinia';
import client from '@/utils/axios/admin';

export const useProfileStore = defineStore('profile', {
  state: () => ({
    subscriber: '',
    loading: false,
    errors: {}, 
  }),

  actions: {
    async getSubscriberDetails() {
      this.loading = true;
      this.errors = {};

      try {
        let res=await client.get('/connex/subscriber-details', {});
        this.subscriber=res.data.data.success;
        return true;  
      } catch (err) {
        if (err.response?.data?.errors) {
          this.errors = { ...err.response.data.errors };
        } else {
          console.warn(err.response?.data?.message || err.message);
        }

        return false;
      } finally {
        this.loading = false;
      }
    },
    async requestReactivate() {
      this.loading = true;
      this.errors = {};

      try {
        let res=await client.post('/connex/subscription-activation', {});
        return true;  
      } catch (err) {
        if (err.response?.data?.errors) {
          this.errors = { ...err.response.data.errors };
        } else {
          console.warn(err.response?.data?.message || err.message);
        }

        return false;
      } finally {
        this.loading = false;
      }
    },
    async confirmReactivate(data) {
      this.loading = true;
      this.errors = {};

      try {
        let res=await client.post('/connex/subscription-activation-confirm', data);
        return true;  
      } catch (err) {
        if (err.response?.data?.errors) {
          this.errors = { ...err.response.data.errors };
        } else {
          console.warn(err.response?.data?.message || err.message);
        }

        return false;
      } finally {
        this.loading = false;
      }
    },
    async requestCancellation() {
      this.loading = true;
      this.errors = {};

      try {
        let res=await client.post('/connex/unsubscribe', {});
        return true;  
      } catch (err) {
        if (err.response?.data?.errors) {
          this.errors = { ...err.response.data.errors };
        } else {
          console.warn(err.response?.data?.message || err.message);
        }

        return false;
      } finally {
        this.loading = false;
      }
    },
    async confirmCancellation(data) {
      this.loading = true;
      this.errors = {};

      try {
        let res=await client.post('/connex/unsubscribe-confirm', data);
        return true;  
      } catch (err) {
        if (err.response?.data?.errors) {
          this.errors = { ...err.response.data.errors };
        } else {
          console.warn(err.response?.data?.message || err.message);
        }

        return false;
      } finally {
        this.loading = false;
      }
    },
 
    clearError(field=null) {
      if (field) {
        delete this.errors[field];
      } else {
        this.errors = {};
      }
    },
  },
});
